import {
  type ChartImage,
  svgToPngDataUrl,
} from '@/components/ui/chart/utils/exportChart'
import { captureException } from '@/services/monitoring/captureException'

export const CHART_EXPORT_ATTRIBUTE = 'data-chart-id'

// The report renders every section (no virtualization), so each chart's
// SVG is already in the DOM when the user exports. Rasterize each one to a
// PNG keyed by its chart id. A chart that never drew a real SVG (an
// unsupported type, a placeholder) is simply absent from the map; the
// renderers fall back to its data table.
export async function collectChartImages(
  chartIds: string[],
): Promise<Map<string, ChartImage>> {
  const images = new Map<string, ChartImage>()
  await Promise.all(
    chartIds.map(async (chartId) => {
      if (!chartId) return
      const svg = findChartSvg(chartId)
      if (!svg) return
      try {
        images.set(chartId, await svgToPngDataUrl(svg))
      } catch (error) {
        captureException(
          error instanceof Error ? error : new Error(String(error)),
        )
      }
    }),
  )
  return images
}

function findChartSvg(chartId: string): SVGSVGElement | null {
  const figure = document.querySelector(
    `[${CHART_EXPORT_ATTRIBUTE}="${CSS.escape(chartId)}"]`,
  )
  return figure?.querySelector('svg') ?? null
}
